import { render, staticRenderFns } from "./SidebarIntent.vue?vue&type=template&id=4f2b572a&scoped=true&"
import script from "./SidebarIntent.vue?vue&type=script&lang=js&"
export * from "./SidebarIntent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarIntent.vue?vue&type=style&index=0&id=4f2b572a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b572a",
  null
  
)

export default component.exports